import type { TColor } from './componentes/types';

/**
 * Maximum character length for the career site title
 */
export const MAX_LENGTH_TITLE = 35;

/**
 * Maximum character length for the career site description
 */
export const MAX_LENGTH_DESCRIPTION = 300;

/**
 * Maximum character length for the call-to-action button text
 */
export const MAX_LENGTH_BUTTON = 25;
/**
 * Maximum character length for the career site vacancies title
 */
export const MAX_LENGTH_TITLE_VACANCIES = 25;

/**
 * Predefined color schemes for the career site header background
 *
 * These colors are stored as JavaScript values to support future custom color selection features.
 * The hexadecimal values are used directly in CSS for portal rendering.
 * Each color scheme includes a primary background color and a secondary accent color.
 */
export const LIST_COLORS: TColor[] = [
  {
    primaryColor: '#E5F9F1', // Light green background
    secondaryColor: '#00655B', // Dark teal accent
  },
  {
    primaryColor: '#FCE6EA', // Light pink background
    secondaryColor: '#C72C43', // Dark red accent
  },
  {
    primaryColor: '#FCEFE9', // Light orange background
    secondaryColor: '#BF4713', // Dark orange accent
  },
  {
    primaryColor: '#F0F2FF', // Light purple background
    secondaryColor: '#70738E', // Dark gray accent
  },
  {
    primaryColor: '#E6F5FF', // Light blue background
    secondaryColor: '#037CCC', // Dark blue accent
  },
  {
    primaryColor: '#F5F0FF', // Light violet background
    secondaryColor: '#4B22F4', // Dark purple accent
  },
];

/**
 * Predefined color schemes for text elements in the career site
 *
 * These colors are stored as JavaScript values to support future custom color selection features.
 * The hexadecimal values are used directly in CSS for portal rendering.
 * Each color scheme includes a primary text color and a secondary text color for different text elements.
 */
export const LIST_COLORS_TEXT: TColor[] = [
  {
    primaryColor: '#0F1019', // Dark text for light backgrounds
    secondaryColor: '#0F1019', // Same dark color for consistency
  },
  {
    primaryColor: '#FFFFFF', // White text for dark backgrounds
    secondaryColor: '#73757A', // Light gray for secondary text
  },
];

/**
 * Predefined color schemes for call-to-action buttons in the career site
 *
 * These colors are stored as JavaScript values to support future custom color selection features.
 * The hexadecimal values are used directly in CSS for portal rendering.
 * Each color scheme includes a primary button color and a secondary hover/active state color.
 */
export const LIST_COLORS_BUTTON: TColor[] = [
  {
    primaryColor: '#00655B', // Teal button
    secondaryColor: '#B8FCDA', // Light teal hover state
  },
  {
    primaryColor: '#C72C43', // Red button
    secondaryColor: '#FFCCD5', // Light red hover state
  },
  {
    primaryColor: '#BF4713', // Orange button
    secondaryColor: '#FFCEB8', // Light orange hover state
  },
  {
    primaryColor: '#FFB200', // Yellow button
    secondaryColor: '#FFE4A6', // Light yellow hover state
  },
  {
    primaryColor: '#037CCC', // Blue button
    secondaryColor: '#A6DBFF', // Light blue hover state
  },
  {
    primaryColor: '#4B22F4', // Purple button
    secondaryColor: '#F5F0FF', // Light purple hover state
  },
];

export const LIST_COLORS_BUTTON_VACANCIES: TColor[] = [
  {
    primaryColor: '#00655B',
    secondaryColor: '#E5F9F1',
  },
  {
    primaryColor: '#C72C43',
    secondaryColor: '#FCE6EA',
  },
  {
    primaryColor: '#BF4713',
    secondaryColor: '#FCEFE9',
  },
  {
    primaryColor: '#FFB200',
    secondaryColor: '#FFF0CC',
  },
  {
    primaryColor: '#037CCC',
    secondaryColor: '#E6F5FF',
  },
  {
    primaryColor: '#4B22F4',
    secondaryColor: '#DFE2FD',
  },
];
